import { render } from "./EditNieuws.vue?vue&type=template&id=85d403dc"
import script from "./EditNieuws.vue?vue&type=script&lang=js"
export * from "./EditNieuws.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__